(function($) {
  'use strict';

  const BundleCollections = {
    // Storage for bundle items
    bundleItems: {},
    carouselPosition: 0,

    // Threshold config — read from window globals set by Liquid
    thresholdAmount: 0,    // e.g. 50000 (cents) — 0 means disabled
    discountPercent: 0,    // e.g. 25
    minQty: 0,             // e.g. 2 — 0 means disabled

    // Initialize the section
    init() {
      this.cacheSelectors();
      this.readThresholdConfig();
      this.bindEvents();
      this.restoreFromStorage();
      this.initCarouselNav();
      this.renderProgressBar();
      this.initExtraProductDefaults();
    },

    // Cache jQuery selectors
    cacheSelectors() {
      this.$section = $('#bundleSection');
      this.$stickyBar = $('#bundleStickyBar');
      this.$stickyList = $('#bundleStickyList');
      this.$stickyQty = $('#bundleStickyQty');
      this.$stickyTotal = $('#bundleStickyTotal');
      this.$addToBundle = $('#bundleAddToCartBtn');
    },

    // Read threshold config injected by Liquid into window globals
    readThresholdConfig() {
      this.thresholdAmount = parseInt(window.bundleThresholdAmount || 0, 10);
      this.discountPercent = parseInt(window.bundleDiscountPercent || 0, 10);
      this.minQty          = parseInt(window.bundleMinQty          || 0, 10);
    },

    // Auto-select first color swatch for every extra product on load
    initExtraProductDefaults() {
        const $firstSwatch = $(".bundle-extra-product").eq(0).find('.bundle-color-swatch-input:first');
        if ($firstSwatch.length) {
          $firstSwatch.prop('checked', true).trigger('change');
        }
      
    },

    // Inject the progress bar HTML above the main CTA
    renderProgressBar() {
      if (!this.thresholdAmount || !this.discountPercent) return;

      const html = `
        <div class="bundle-progress-wrap" id="bundleProgressWrap">
          <div class="bundle-progress-message" id="bundleProgressMsg"></div>
          <div class="bundle-progress-track">
            <div class="bundle-progress-fill" id="bundleProgressFill" style="width:0%"></div>
          </div>
        </div>`;

      // Insert just above the add-to-bundle button
      this.$addToBundle.before(html);
      this.updateProgressBar();
    },

    // Update progress bar state
    // Threshold is based on collection product value only (non-extra items)
    // The bag discount is a bonus — users can always checkout with or without a bag
    updateProgressBar() {
      if (!this.thresholdAmount || !this.discountPercent) return;

      const totals = this.calculateTotalRaw();
      // Threshold is based on ALL items combined (collection products + bag)
      const totalCents = totals.priceCents;
      const qty        = totals.quantity;

      const percent      = Math.min(100, Math.round((totalCents / this.thresholdAmount) * 100));
      const thresholdMet = totalCents >= this.thresholdAmount;
      const minQtyMet    = (this.minQty === 0) || (qty >= this.minQty);
      const allMet       = thresholdMet && minQtyMet;

      // Check if a bag (extra product) has been added
      const hasBag = Object.values(this.bundleItems).some(item => item.isExtra);

      // Progress fill — tracks total spend toward threshold
      $('#bundleProgressFill').css('width', percent + '%');

      // Message — 4 distinct states
      const $msg = $('#bundleProgressMsg');
      if (hasBag && allMet) {
        // ✅ Bag added + threshold met → discount confirmed
        $msg.html(`<span class="bundle-progress-success">🎉 כל הכבוד! קיבלת ${this.discountPercent}% הנחה על התיק!</span>`);
        $('#bundleProgressWrap').addClass('bundle-progress-done');

      } else if (hasBag && !allMet) {
        // 🛍️ Bag added but total spend not enough yet
        const remaining          = this.thresholdAmount - totalCents;
        const remainingFormatted = this.formatPriceCents(remaining);
        $msg.html(`<span class="bundle-progress-hint">🛍️ הוסיפי עוד ${remainingFormatted} לקבלת ${this.discountPercent}% הנחה על התיק</span>`);
        $('#bundleProgressWrap').removeClass('bundle-progress-done');

      } else if (!hasBag && allMet) {
        // 🎁 Threshold met — invite them to add a bag for the discount
        $msg.html(`<span class="bundle-progress-hint">🎁 כל הכבוד! הוסיפי תיק עכשיו וקבלי ${this.discountPercent}% הנחה עליו!</span>`);
        $('#bundleProgressWrap').removeClass('bundle-progress-done');

      } else {
        // ⏳ Below threshold, no bag yet — show how much is left
        const remaining          = this.thresholdAmount - totalCents;
        const remainingFormatted = this.formatPriceCents(remaining);
        $msg.html(`<span class="bundle-progress-hint">🛍️ הוסיפי עוד ${remainingFormatted} וקבלי ${this.discountPercent}% הנחה על תוספת תיק!</span>`);
        $('#bundleProgressWrap').removeClass('bundle-progress-done');
      }

      // ✅ Button always enabled as long as there's at least 1 item — bag is optional
      this.$addToBundle.prop('disabled', qty === 0);

      // Discount on bag only applies when bag is present AND total threshold is met
      this.updateStickyPrices(allMet && hasBag);
    },

    // Apply/remove discount badge + strikethrough on sticky items
    // Only extra products (extra_product_1, extra_product_2) get discounted
    // Collection products always show full price
    updateStickyPrices(discountActive) {
      if (!this.discountPercent) return;

      this.$stickyList.find('.bundle-sticky-item').each(function() {
        const productId = $(this).data('product-id');
        const variantId = String($(this).attr('data-variant-id') || '');

        const key = Object.keys(BundleCollections.bundleItems).find(k => {
          const it = BundleCollections.bundleItems[k];
          return String(it.productId) === String(productId) &&
                 String(it.variantId || '') === variantId;
        });

        if (!key) return;

        const item     = BundleCollections.bundleItems[key];
        const original = item.priceCents;

        const $priceEl = $(this).find('.bundle-sticky-item-price');
        const $badge   = $(this).find('.bundle-discount-badge');

        // Collection products — always full price, no badge ever
        if (!item.isExtra) {
          $priceEl.html(BundleCollections.formatPriceCents(original));
          $badge.remove();
          return;
        }

        // Extra products — apply discount when threshold met
        const discounted = Math.round(original * (1 - BundleCollections.discountPercent / 100));

        if (discountActive) {
          $priceEl.html(
            `<span class="bundle-price-original">${BundleCollections.formatPriceCents(original)}</span>
             <span class="bundle-price-discounted">${BundleCollections.formatPriceCents(discounted)}</span>`
          );
          if (!$badge.length) {
            $(this).find('.bundle-sticky-item-info').append(
              `<span class="bundle-discount-badge">-${BundleCollections.discountPercent}%</span>`
            );
          }
        } else {
          $priceEl.html(BundleCollections.formatPriceCents(original));
          $badge.remove();
        }
      });

      // Update sticky total:
      // collection products at full price + extra products at discounted price (if discount active)
      const totals = this.calculateTotalRaw();
      if (discountActive && this.discountPercent) {
        const collectionCents  = totals.priceCents - totals.mainCents;
        const discountedExtra  = Math.round(totals.mainCents * (1 - this.discountPercent / 100));
        const discountedTotal  = collectionCents + discountedExtra;
        this.$stickyTotal.html(
          `<span class="bundle-price-original">${this.formatPriceCents(totals.priceCents)}</span>
           <span class="bundle-price-discounted">${this.formatPriceCents(discountedTotal)}</span>`
        );
      } else {
        this.$stickyTotal.text(this.formatPriceCents(totals.priceCents));
      }
    },

    // Bind event handlers
    bindEvents() {
      const self = this;

      // Variant selection
      this.$section.on('change', '.bundle-swatch-input', function() {
        const $card = $(this).closest('.bundle-product-card');
        self.enableAddToCartButton($card);
      });

      // Add to cart button click
      this.$section.on('click', '.bundle-add-to-cart-btn', function(e) {
        e.preventDefault();
        const $card = $(this).closest('.bundle-product-card');
        self.handleAddToCart($card);
      });

      // Quantity increment/decrement
      this.$section.on('click', '.bundle-qty-plus', function() {
        const $card = $(this).closest('.bundle-product-card');
        self.incrementQuantity($card);
      });

      this.$section.on('click', '.bundle-qty-minus', function() {
        const $card = $(this).closest('.bundle-product-card');
        self.decrementQuantity($card);
      });

      // Remove from sticky bar
      this.$stickyList.on('click', '.bundle-sticky-item-remove', function() {
        const productId = $(this).closest('.bundle-sticky-item').data('product-id');
        const variantId = $(this).closest('.bundle-sticky-item').attr('data-variant-id');
        self.removeFromBundle(productId, variantId);
      });

      // Add to bundle (main button)
      this.$addToBundle.on('click', function(e) {
        e.preventDefault();
        if (!$(this).prop('disabled')) {
          self.addAllToCart();
        }
      });

      // Carousel navigation
      this.$stickyBar.on('click', '.bundle-carousel-prev', function() {
        self.slideCarousel('prev');
      });

      this.$stickyBar.on('click', '.bundle-carousel-next', function() {
        self.slideCarousel('next');
      });

      this.$stickyBar.on('click', '.bundle-carousel-dot', function() {
        const index = $(this).data('index');
        self.goToCarouselSlide(index);
      });
    },

    // Handle add to cart
    handleAddToCart($card) {
      const $btn      = $card.find('.bundle-add-to-cart-btn');
      const $selector = $card.find('.bundle-quantity-selector');

      $btn.hide();
      $selector.show();
      $selector.find('.bundle-qty-value').text('1');

      this.addProductToBundle($card, 1);
    },

    // Enable add to cart button based on variant selection
    enableAddToCartButton($card) {
      const hasVariants = $card.find('.bundle-variant-swatches').length > 0;
      if (hasVariants) {
        const isSelected = $card.find('.bundle-swatch-input:checked').length > 0;
        $card.find('.bundle-add-to-cart-btn').prop('disabled', !isSelected);
      }
    },

    // Increment quantity
    incrementQuantity($card) {
      const $qty       = $card.find('.bundle-qty-value');
      const currentQty = parseInt($qty.text()) || 1;
      const newQty     = currentQty + 1;

      $qty.text(newQty);
      this.updateBundleItemQuantity($card, newQty);
    },

    // Decrement quantity
    decrementQuantity($card) {
      const $qty       = $card.find('.bundle-qty-value');
      const currentQty = parseInt($qty.text()) || 1;

      if (currentQty > 1) {
        const newQty = currentQty - 1;
        $qty.text(newQty);
        this.updateBundleItemQuantity($card, newQty);
      } else if (currentQty === 1) {
        $card.find('.bundle-quantity-selector').hide();
        $card.find('.bundle-add-to-cart-btn').show();
        this.removeProductFromBundle($card);
      }
    },

    // Add product to bundle
    addProductToBundle($card, qty) {
      const productId     = $card.data('product-id');
      const productHandle = $card.data('product-handle');
      const productTitle  = $card.find('.bundle-product-title').text();
      const productImage  = $card.find('.bundle-product-image img').attr('src');

      // Grab raw price in cents — always read fresh from attr (may be updated by swatch change handler)
      const priceCents   = parseInt($card.attr('data-price-cents') || 0, 10);
      const productPrice = this.formatPriceCents(priceCents);

      // TRUE for bag/extra products — card has class extra-product-card
      // Also check parent wrapper in case card is nested inside .bundle-extra-product
      const isExtra = $card.hasClass('extra-product-card') ||
                      $card.closest('.bundle-extra-product').length > 0;

      let variantId    = null;
      let variantTitle = null;

      // 1️⃣ Normal variant swatches
      let $selectedVariant = $card.find('.bundle-swatch-input:checked');
      if ($selectedVariant.length > 0) {
        variantId    = $selectedVariant.val();
        variantTitle = $selectedVariant.data('variant-title');
      }

      // 2️⃣ Extra product color swatches
      if (!variantId) {
        const $colorSwatch = $card.parents('.bundle-extra-product').find('.bundle-color-swatch-input:checked');
        if ($colorSwatch.length > 0) {
          variantTitle = $colorSwatch.val();
          variantId    = $card.find('.extra-add-btn').attr('data-variant-id');
        }
      }

      // 3️⃣ Fallback to first swatch
      if (!variantId) {
        const $firstVariant = $card.find('.bundle-swatch-input:first');
        if ($firstVariant.length > 0) {
          variantId    = $firstVariant.val();
          variantTitle = $firstVariant.data('variant-title');
        }
      }

      const key = `${productId}_${variantId}`;

      this.bundleItems[key] = {
        productId,
        productHandle,
        variantId,
        productTitle,
        variantTitle,
        productImage,
        productPrice,
        priceCents,
        isExtra,      // true = extra_product (discountable bag), false = collection product (full price)
        quantity: qty
      };

      this.saveToStorage();
      this.updateStickyBar();
    },

    // Update bundle item quantity
    updateBundleItemQuantity($card, newQty) {
      const productId = $card.data('product-id');
      const key = Object.keys(this.bundleItems).find(k =>
        this.bundleItems[k].productId == productId
      );
      if (this.bundleItems[key]) {
        this.bundleItems[key].quantity = newQty;
        this.saveToStorage();
        this.updateStickyBar();
      }
    },

    // Remove product from bundle (from card UI)
    removeProductFromBundle($card) {
      const productId = $card.data('product-id');
      const key = Object.keys(this.bundleItems).find(k =>
        this.bundleItems[k].productId == productId
      );
      if (key) {
        delete this.bundleItems[key];
        this.saveToStorage();
        this.updateStickyBar();
      }
    },

    // Remove from bundle via sticky bar
    removeFromBundle(productId, variantId) {
      productId = String(productId);
      variantId = variantId ? String(variantId) : '';

      const key = Object.keys(this.bundleItems).find(k => {
        return (
          String(this.bundleItems[k].productId) === productId &&
          String(this.bundleItems[k].variantId || '') === variantId
        );
      });

      if (!key) return;

      delete this.bundleItems[key];

      const $card = this.$section.find(`[data-product-id="${productId}"]`);
      if ($card.length) {
        $card.find('.bundle-quantity-selector').hide();
        $card.find('.bundle-add-to-cart-btn').show();
        $card.find('.bundle-qty-value').text('1');
        if (variantId) {
          $card.find(`.bundle-swatch-input[value="${variantId}"]`).prop('checked', false);
        }
      }

      this.saveToStorage();
      this.updateStickyBar();
    },

    // ─── Price helpers ────────────────────────────────────────────────────────

    formatPriceCents(cents) {
      if (window.bundleCurrency && window.bundleLocale) {
        return new Intl.NumberFormat(window.bundleLocale, {
          style: 'currency',
          currency: window.bundleCurrency
        }).format(cents / 100);
      }
      return '₪' + (cents / 100).toFixed(2);
    },

    parsePriceToNumber(priceStr) {
      return parseFloat(priceStr.replace(/[^0-9.-]+/g, ''));
    },

    // ─── Totals ───────────────────────────────────────────────────────────────

    // priceCents = ALL items combined (for display)
    // mainCents  = extra products (bags) only — used for discount calc on the bag itself
    calculateTotalRaw() {
      let totalQty   = 0;
      let totalCents = 0;
      let mainCents  = 0; // extra products (bags) only

      $.each(this.bundleItems, (key, item) => {
        totalQty += item.quantity;
        const cents = item.priceCents
          ? item.priceCents
          : Math.round(this.parsePriceToNumber(item.productPrice) * 100);
        totalCents += cents * item.quantity;

        // Only extra products (bags) tracked separately for discount calc
        if (item.isExtra) {
          mainCents += cents * item.quantity;
        }
      });

      return { quantity: totalQty, priceCents: totalCents, mainCents };
    },

    // Legacy helper kept for any remaining calls
    calculateTotal() {
      const raw = this.calculateTotalRaw();
      return {
        quantity: raw.quantity,
        price: (raw.priceCents / 100).toFixed(2)
      };
    },

    formatPrice(price) {
      return '$' + parseFloat(price).toFixed(2);
    },

    // ─── Sticky bar ───────────────────────────────────────────────────────────

    updateStickyBar() {
      const totals = this.calculateTotalRaw();

      this.$stickyQty.text(totals.quantity);

      // Default total text (may be overridden by updateProgressBar → updateStickyPrices)
      this.$stickyTotal.text(this.formatPriceCents(totals.priceCents));

      // If no threshold configured, enable/disable based on qty only
      if (!this.thresholdAmount) {
        this.$addToBundle.prop('disabled', totals.quantity === 0);
      }

      this.renderStickyList();
      this.updateProgressBar();
    },

    // Render sticky bar product list
    renderStickyList() {
      this.$stickyList.empty();
      let itemCount = 0;

      $.each(this.bundleItems, (key, item) => {
        const html = `
          <div class="bundle-sticky-item" data-product-id="${item.productId}" data-variant-id="${item.variantId || ''}">
            <div class="bundle-sticky-item-image">
              <img src="${item.productImage}" alt="${item.productTitle}">
            </div>
            <div class="bundle-sticky-item-info">
              <button class="bundle-sticky-item-remove" aria-label="Remove">×</button>
              <div class="bundle-sticky-item-title">${item.productTitle}</div>
              ${item.variantTitle ? `<div class="bundle-sticky-item-variant">${item.variantTitle}</div>` : ''}
              <div class="bundle-sticky-item-price">${item.productPrice}</div>
            </div>
            <div class="bundle-sticky-item-qty">x${item.quantity}</div>
          </div>`;
        this.$stickyList.append(html);
        itemCount++;
      });

      this.renderCarouselDots(itemCount);
      setTimeout(() => this.updateCarouselNav(), 50);
    },

    renderCarouselDots(itemCount) {
      const $dotsContainer = this.$stickyBar.find('#bundleCarouselDots');
      $dotsContainer.empty();
      const count = itemCount - 1;
      for (let i = 0; i < count; i++) {
        const dotClass = i === 0 ? 'active' : '';
        $dotsContainer.append(
          `<button class="bundle-carousel-dot ${dotClass}" data-index="${i}" aria-label="Item ${i + 1}"></button>`
        );
      }
    },

    // ─── Cart submission ──────────────────────────────────────────────────────

 addAllToCart() {
  const self   = this;
  const items  = [];
  const totals = this.calculateTotalRaw();

  const hasBag = Object.values(this.bundleItems).some(item => item.isExtra);
  const discountActive =
    hasBag &&
    this.thresholdAmount &&
    totals.priceCents >= this.thresholdAmount &&
    (this.minQty === 0 || totals.quantity >= this.minQty);

  $.each(this.bundleItems, (key, item) => {
    if (item.variantId) {
      const lineItem = {
        id: item.variantId,
        quantity: item.quantity
      };

      if (discountActive && this.discountPercent && item.isExtra) {
        lineItem.properties = {
          '_bundle_discount': `${this.discountPercent}%`
        };
      }

      items.push(lineItem);
    }
  });

  if (items.length === 0) {
    alert('No items to add. Please select products first.');
    return;
  }

  this.$addToBundle.addClass('loading');
  this.removeBundleSuccessMessage();

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    contentType: 'application/json',
    data: JSON.stringify({ items }),
    dataType: 'json',
    success: function () {
      self.bundleItems = {};
      self.saveToStorage();

      $.ajax({
        url: '/',
        type: 'GET',
        dataType: 'html',
        success: function (data) {
          $('#CartDrawer').html($(data).find('#CartDrawer').html());
          $("cart-drawer.drawer").removeClass('is-empty');
          $('a#cart-icon-bubble').html($(data).find('a#cart-icon-bubble').html());
          $('#bundleAddToCartBtn').removeClass('loading');

          const nextStepLink = self.getNextStepLink();

          if (nextStepLink) {
            self.showBundleSuccessMessage(nextStepLink);
          } else {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.open();
          }

          self.updateStickyBar();
        }
      });
    },
    error: function (xhr) {
      self.$addToBundle.removeClass('loading');

      let errorMsg = 'There was an error adding items to your cart. ';
      if (xhr.status === 422) {
        errorMsg += 'Some items may be out of stock.';
      } else if (xhr.responseJSON && xhr.responseJSON.description) {
        errorMsg += xhr.responseJSON.description;
      } else {
        errorMsg += 'Please try again.';
      }

      alert(errorMsg);
    }
  });
},

showBundleSuccessMessage(nextStepLink) {
  $(".bundle-sticky-totals").hide();
    $("button#bundleAddToCartBtn").hide();

  const messageHtml = `
    <div class="bundle-success-message">
      <div class="bundle-success-text">
      ✓ נוסף בהצלחה
      </div>
      <a href="${nextStepLink}" class="bundle-next-step-button">
    <span class="bundle-btn-text">המשיכו לשלב הבא</span>
    <span class="bundle-btn-icon">←</span>
</a>
    </div>
  `;

  $('.bundle-success-message').remove();
  $('#bundleAddToCartBtn').after(messageHtml);
},

removeBundleSuccessMessage() {
  $('.bundle-success-message').remove();
},

getNextStepLink() {
  const progressBar = document.querySelector('.nfm-steps');
  if (!progressBar) return null;

  const activeStep = progressBar.querySelector('.nfm-step.active');
  if (!activeStep) return null;

  const allSteps = Array.from(progressBar.querySelectorAll('.nfm-step'));
  const activeIndex = allSteps.indexOf(activeStep);
  const nextStep = allSteps[activeIndex + 1];

  return nextStep ? nextStep.getAttribute('href') : null;
},

    // ─── Storage ──────────────────────────────────────────────────────────────

    saveToStorage() {
      localStorage.setItem('bundleItems', JSON.stringify(this.bundleItems));
    },

    restoreFromStorage() {
      const stored = localStorage.getItem('bundleItems');
      if (!stored) return;

      try {
        this.bundleItems = JSON.parse(stored);

        Object.values(this.bundleItems).forEach(item => {
          const $card = this.$section.find(`[data-product-id="${item.productId}"]`);
          if ($card.length) {
            if (item.variantId) {
              $card.find(`.bundle-swatch-input[value="${item.variantId}"]`).prop('checked', true);
            }
            if (item.variantTitle) {
              const $colorSwatch = $card.find(`.bundle-color-swatch-input[value="${item.variantTitle}"]`);
              if ($colorSwatch.length) {
                $colorSwatch.prop('checked', true).trigger('change');
              }
            }
            $card.find('.bundle-add-to-cart-btn').hide();
            $card.find('.bundle-quantity-selector').show();
            $card.find('.bundle-qty-value').text(item.quantity);
          }
        });

        this.updateStickyBar();
      } catch (e) {
        console.error('Error restoring bundle:', e);
      }
    },

    // ─── Carousel ─────────────────────────────────────────────────────────────

    initCarouselNav() {
      this.$stickyList.on('scroll', () => this.updateCarouselNav());
    },

    slideCarousel(direction) {
      const container = this.$stickyList[0];
      if (!container) return;
      const scrollAmount = $(window).width() < 768 ? 220 : 270;
      container.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    },

    goToCarouselSlide(index) {
      const $items = this.$stickyList.find('.bundle-sticky-item');
      if (!$items.length) return;
      const container = this.$stickyList[0];
      const item      = $items[index];
      if (!item) return;

      let scrollPos   = item.offsetLeft;
      const maxScroll = container.scrollWidth - container.clientWidth;
      if (scrollPos > maxScroll) scrollPos = maxScroll;

      container.scrollTo({ left: scrollPos, behavior: 'smooth' });
      setTimeout(() => this.updateCarouselNav(), 300);
    },

    updateCarouselNav() {
      const $carousel   = this.$stickyList;
      const scrollLeft  = $carousel.scrollLeft();
      const scrollWidth = $carousel[0].scrollWidth;
      const clientWidth = $carousel[0].clientWidth;
      const hasOverflow = scrollWidth > clientWidth + 5;

      const $prevBtn       = this.$stickyBar.find('.bundle-carousel-prev');
      const $nextBtn       = this.$stickyBar.find('.bundle-carousel-next');
      const $dotsContainer = this.$stickyBar.find('#bundleCarouselDots');

      if (!hasOverflow) {
        $prevBtn.hide();
        $nextBtn.hide();
        $dotsContainer.hide();
        return;
      }

      $prevBtn.show();
      $nextBtn.show();
      $dotsContainer.show();

      $prevBtn.prop('disabled', scrollLeft <= 0);
      $nextBtn.prop('disabled', scrollLeft >= scrollWidth - clientWidth - 5);

      const container     = this.$stickyList[0];
      const $items        = this.$stickyList.find('.bundle-sticky-item');
      const containerLeft = container.scrollLeft;

      let activeIndex      = 0;
      let smallestDistance = Infinity;

      $items.each(function(index) {
        const distance = Math.abs(this.offsetLeft - containerLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex      = index;
        }
      });

      this.$stickyBar.find('.bundle-carousel-dot').removeClass('active');
      this.$stickyBar.find(`.bundle-carousel-dot[data-index="${activeIndex}"]`).addClass('active');
    }
  };

  // ─── Color swatch change handler ─────────────────────────────────────────────

  $(document).on('change', '.bundle-color-swatch-input', function() {
    const $wrapper      = $(this).closest('.bundle-extra-product');
    const $card         = $wrapper.find('.extra-product-card');
    const selectedColor = $(this).val();
    const variants      = JSON.parse($wrapper.find('.extra-product-variants').html() || '[]');

    const variant = variants.find(v => v.options.includes(selectedColor));
    if (!variant) return;

    if (variant.featured_image) {
      $card.find('.extra-selected-image').attr('src', variant.featured_image.src);
    }

    $card.find('.extra-selected-price').text(
      BundleCollections.formatPriceCents(variant.price)
    );

    $card.find('.extra-add-btn')
      .attr('data-variant-id', variant.id)
      .attr('data-price-cents', variant.price)   // store cents for threshold calc
      .prop('disabled', false);

    // Also update data-price-cents on the card itself
    $card.attr('data-price-cents', variant.price);

    $card.show();
  });

  // ─── Bootstrap ───────────────────────────────────────────────────────────────

  $(document).ready(function() {
    BundleCollections.init();
  });

  $(window).on('resize', function() {
    BundleCollections.updateCarouselNav();
  });

})(jQuery);